import { X } from 'lucide-react'
import { toast } from 'sonner'

interface KioskToastProps {
  toastId: string | number
  message: string
  color: string
  backgroundColor: string
  onAction?: () => void
  actionLabel?: string
}

const KioskToast = ({
  toastId,
  message,
  color,
  backgroundColor,
  onAction,
  actionLabel,
}: KioskToastProps) => (
  <div
    className="flex items-center gap-3 w-full rounded-xl shadow-lg overflow-hidden cursor-pointer select-none"
    style={{ borderLeft: `5px solid ${color}`, background: backgroundColor }}
    onClick={() => {
      onAction?.()
      toast.dismiss(toastId)
    }}
  >
    <div className="flex items-center gap-3 flex-1 px-5 py-5">
      <div className="w-2.5 h-2.5 rounded-full shrink-0" style={{ background: color }} />
      <p className="text-sm text-gray-800 leading-snug flex-1">{message}</p>
    </div>

    {onAction && actionLabel && (
      <button
        className="text-xs font-semibold px-3 py-1 mr-2 rounded-full text-white shrink-0 transition-opacity hover:opacity-80"
        style={{ background: color }}
        onClick={(e) => {
          e.stopPropagation()
          onAction()
          toast.dismiss(toastId)
        }}
      >
        {actionLabel}
      </button>
    )}

    <button
      className="p-3 text-gray-400 hover:text-gray-600 transition-colors shrink-0"
      onClick={(e) => {
        e.stopPropagation()
        toast.dismiss(toastId)
      }}
    >
      <X className="w-3.5 h-3.5" />
    </button>
  </div>
)

export default KioskToast
